<template>
  <div class="mt-6">
    <h3 class="text-lg font-medium text-gray-900 mb-4">Magasins associés</h3>
    <Table :columns="columns" :data="stores">
      <template #salesChannel="{ row }">
        <router-link :to="`/stores/${row.id}`" class="text-primary hover:text-primary-dark font-medium">
          {{ row.salesChannel }}
        </router-link>
      </template>
    </Table>
  </div>
</template>

<script>
import { Table } from "@estaly/ui";

export default {
  components: { Table },
  props: {
    stores: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      columns: [
        { label: "ID", field: "id" },
        { label: "Nom", field: "salesChannel", slot: "salesChannel" },
        { label: "Source", field: "source" },
      ],
    };
  },
};
</script>
